<script>
import lazyLoadComponent from '@router/lazyload-component'
import { merchantComputed } from '@state/helpers'

export default {
  components: {
    FileUpload: () => lazyLoadComponent(import('@views/chat/components/FileUpload')),
  },
  props: {
    // 父層 index.vue 抓到的資料：/admin/merchant/setting { type: 'hotel' } 回傳的 data
    hotelInfo: {
      type: Object,
      default: () => null,
    },
    // 父層控制 loading（抓取/儲存）
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploaderKey: 0,
      storeStatus: false,
      createLoading: false,
      submitData: {
        // === 對應後端 payload 結構 ===
        isEnabled: 0,
        title: '',
        allowNewCustomer: 0,
        addEnabled: 0,
        showCheckoutDate: 0,
        bannerImages: [],
        bannerText: '',
        description: '',
        checkinNote: '',
        terms: '',
        productSetting: [],
      },
    }
  },
  computed: {
    ...merchantComputed,
    useDefaultTerms() {
      return this.submitData.terms === this.formatPrepaidTerms
    },
    submitRules() {
      return {
        title: [{ required: true, message: '請輸入選單名稱', trigger: 'blur' }],
        description: [{ required: true, message: '請輸入住宿介紹', trigger: 'blur' }],
        checkinNote: [{ required: true, message: '請輸入入住須知', trigger: 'blur' }],
        terms: [{ required: true, message: '請輸入條款說明', trigger: 'blur' }],
      }
    },
    formatPrepaidTerms() {
      return `${this.currentMerchant.name || '店家'}住宿服務注意事項

${this.currentMerchant.name || '店家'}（後稱「本店」）提供「寵物住宿服務」（後稱「本服務」），以下為本服務使用規則說明：

一. 飼主應針對寵物身體狀況盡告知義務，若因隱瞞病況發生意外或死亡，經法定程序判定店家無疏失，本店無須負損害賠償責任。
二. 飼主應於住宿當日將寵物領回，如經通知1日內未領回，依動保法第29條第一款通知主管機關，為飼主惡意棄養，相關罰金為3萬～15萬元，其他衍生性費用將跟飼主求償，例：人員加班費等。
三. 寵物發生攻擊行為，如因飼主未善盡告知義務而造成店內人員傷亡、財物損毀等費用，將全額向飼主（寵物占有權人）求償。
四. 店家應按本契約約定內容提供一定品質之住宿服務。若因可歸責於店家或其受雇人之事由，導致其提供之住宿服務有瑕玼，造成飼主發生損失的情況，飼主得要求減少價金或減除契約。
五. 本契約之任一方得隨時終止本契約，若因本契約之終止而生損害之一方得向他方請求賠償。
六. 於住宿服務期間，如發現寵物有異常狀態，應立即通知飼主並妥善處理，如發生異常狀態的原因可歸貴店家之操作行為，店家應負損害賠償的責任，例：摔傷寵物等。
七. 除本合約另有約定、特殊緊急情況，或不可抗力之情況外，未經飼主同意，本店不得將寵物帶離住宿場所（同上店家地址）、轉售、轉讓或以其他變相方法作為其他用途。
八. 本合約之任何條款或部分如因任何理由被認定為無效或無法執行者，其無效或無法執行以該條款或部分為限，不影響其他條款或該條款其他部分之有效性。
九. 本合約之準據法為中華民國法律。因本合約涉訟時，雙方同意以司法院公告本店所屬轄區之地方法院為第一審管轄法院。
`
    },
  },

  watch: {
    // 父層資料進來時，灌進表單（不打 API）
    hotelInfo: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val) return
        this.applyHotelInfoToForm(val)
      },
    },
    'submitData.terms': {
      handler() {
        this.$forceUpdate()
      },
    },
  },

  methods: {
    applyHotelInfoToForm(data) {
      // 完整對應你的後端結構
      this.submitData.isEnabled = Number(data.isEnabled) || 0
      this.submitData.title = data.title || ''
      this.submitData.allowNewCustomer = Number(data.allowNewCustomer) || 0
      this.submitData.addEnabled = Number(data.addEnabled) || 0
      this.submitData.showCheckoutDate = Number(data.showCheckoutDate) || 0
      this.submitData.bannerImages = Array.isArray(data.bannerImages) ? data.bannerImages : []
      this.submitData.bannerText = data.bannerText || ''
      this.submitData.description = data.description || ''
      this.submitData.checkinNote = data.checkinNote || ''
      this.submitData.terms = data.terms || ''
      this.submitData.productSetting = Array.isArray(data.productSetting) ? data.productSetting : []
      this.uploaderKey += 1
    },

    buildPayload() {
      // 子層只負責組 payload，交給父層打 store API
      return {
        isEnabled: Number(this.submitData.isEnabled) || 0,
        title: this.submitData.title || '',
        allowNewCustomer: Number(this.submitData.allowNewCustomer) || 0,
        addEnabled: Number(this.submitData.addEnabled) || 0,
        showCheckoutDate: Number(this.submitData.showCheckoutDate) || 0,
        bannerImages: Array.isArray(this.submitData.bannerImages) ? this.submitData.bannerImages : [],
        bannerText: this.submitData.bannerText || '',
        description: this.submitData.description || '',
        checkinNote: this.submitData.checkinNote || '',
        terms: this.submitData.terms || '',
        productSetting: Array.isArray(this.submitData.productSetting) ? this.submitData.productSetting : [],
      }
    },

    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return this.$message.error('尚有必填資料未填寫')
        const payload = this.buildPayload()
        this.$emit('save', payload)
      })
    },

    cancel() {
      if (this.hotelInfo) this.applyHotelInfoToForm(this.hotelInfo)
      this.$emit('cancel')
    },

    setDefaultContact(checked) {
      if (checked) {
        this.submitData.terms = this.formatPrepaidTerms
      } else {
        this.submitData.terms = ''
      }
    },
  },
}
</script>

<template>
  <div class="outer">
    <div :class="$style.container" v-loading="loading" element-loading-text="載入中...">
      <el-form ref="form" :model="submitData" label-position="top" :rules="submitRules">
        <div>
          <h4 data-tour-text="" class="form-block-title justify-content-start fs-lg">
            <span>選單名稱</span>
            <span class="ml-3 text-danger text-secondary fs-sm">此名稱會顯示在前台</span>
          </h4>
          <el-form-item prop="title">
            <el-input v-model="submitData.title" />
          </el-form-item>
        </div>

        <el-divider></el-divider>

        <div class="inline-between">
          <h3 style="font-size:16px;">是否啟用住宿功能?</h3>
          <el-form-item label="" class="mb-0">
            <el-switch v-model="submitData.isEnabled" active-text="啟用" inactive-text="停用" :active-value="1" :inactive-value="0" />
          </el-form-item>
        </div>

        <el-divider></el-divider>

        <div class="inline-between">
          <h3 style="font-size:16px;">是否接受新客?</h3>
          <el-form-item label="" class="mb-0">
            <el-switch v-model="submitData.allowNewCustomer" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0" />
          </el-form-item>
        </div>

        <el-divider></el-divider>

        <div class="inline-between">
          <h3 style="font-size:16px;">是否開放前台加購？</h3>
          <el-form-item label="" class="mb-0">
            <el-switch v-model="submitData.addEnabled" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0" />
          </el-form-item>
        </div>

        <el-divider></el-divider>

        <div class="inline-between">
          <h3 style="font-size:16px; display:flex; align-items:center;">
            <span>計價方式</span>
            <el-popover placement="right" width="640" trigger="click" popper-class="show-checkout-date-popover">
              <div>
                <h4 style="margin:0 0 8px; font-size:16px;">計價方式顯示說明</h4>
                <p style="margin:0 0 12px; color:#606266; line-height:1.5;">
                  提供住宿業者依照自身營運習慣，選擇以晚或以天呈現住宿期間（不影響實際計價金額）
                </p>
                <p style="margin:0 0 8px; color:#606266; line-height:1.5;">範例說明：</p>
                <table style="width:100%; border-collapse:collapse; font-size:13px;">
                  <thead>
                    <tr>
                      <th style="border:1px solid #ebeef5; padding:8px; background:#f5f7fa; text-align:left;">項目</th>
                      <th style="border:1px solid #ebeef5; padding:8px; background:#f5f7fa; text-align:left;">以晚</th>
                      <th style="border:1px solid #ebeef5; padding:8px; background:#f5f7fa; text-align:left;">以天</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="border:1px solid #ebeef5; padding:8px;">入住日期</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">08/01</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">08/01</td>
                    </tr>
                    <tr>
                      <td style="border:1px solid #ebeef5; padding:8px;">退房日期</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">08/05</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">08/04</td>
                    </tr>
                    <tr>
                      <td style="border:1px solid #ebeef5; padding:8px;">前台顯示天數</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">5天4晚</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">4天</td>
                    </tr>
                    <tr>
                      <td style="border:1px solid #ebeef5; padding:8px;">後台顯示天數</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">合計4晚</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">合計4天</td>
                    </tr>
                    <tr>
                      <td style="border:1px solid #ebeef5; padding:8px;">價格計算</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">$4,000</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">$4,000</td>
                    </tr>
                    <tr>
                      <td style="border:1px solid #ebeef5; padding:8px;">實際金額</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">不變</td>
                      <td style="border:1px solid #ebeef5; padding:8px;">不變</td>
                    </tr>
                    <tr>
                      <td style="border:1px solid #ebeef5; padding:8px;">適合業者</td>
                      <td style="border:1px solid #ebeef5; padding:8px; white-space:nowrap;">習慣呈現完整入住～退房區間</td>
                      <td style="border:1px solid #ebeef5; padding:8px; white-space:nowrap;">習慣以實際住宿天數呈現</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <BaseIcon slot="reference" name="info-circle" class="text-text-light ml-2" style="cursor:pointer;" />
            </el-popover>
          </h3>
          <el-form-item label="" class="mb-0">
            <el-radio-group v-model="submitData.showCheckoutDate">
              <el-radio :label="1">以晚</el-radio>
              <el-radio :label="0">以天</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <el-divider></el-divider>

        <div>
          <h4 data-tour-text="" class="form-block-title mt-0 fs-lg">
            <span>Banner圖片</span>
          </h4>
          <el-form-item>
            <div :class="$style.uploaderContainer">
              <FileUpload
                :key="uploaderKey"
                v-model="submitData.bannerImages"
                :class="$style.uploaderContainer_uploader"
                :single="true"
                is-delete-save
                :show-upload="true"
                resource="hotel"
                :size-limit="2"
              ></FileUpload>
              <div :class="[$style.limit]">
                圖檔最大 2 MB，檔案格式限 JPG 或 PNG。
                <br />
                圖片比例：16：9，建議尺寸：1920*600px
              </div>
            </div>
          </el-form-item>
        </div>

        <div>
          <h4 data-tour-text="" class="form-block-title mt-0 fs-lg">
            <span>Banner文字簡介</span>
          </h4>
          <el-form-item label="">
            <el-input v-model="submitData.bannerText" type="textarea" class="is-border is-round bg-white" :autosize="{ minRows: 5 }" />
          </el-form-item>
        </div>

        <div>
          <h4 data-tour-text="" class="form-block-title mt-0 fs-lg">
            <span class="isStyleRequired">住宿介紹</span>
          </h4>
          <el-form-item label="" prop="description">
            <el-input v-model="submitData.description" type="textarea" class="is-border is-round bg-white" :autosize="{ minRows: 5 }" />
          </el-form-item>
        </div>

        <div>
          <h4 data-tour-text="" class="form-block-title mt-0 fs-lg">
            <span class="isStyleRequired">入住須知</span>
          </h4>
          <el-form-item label="" prop="checkinNote">
            <el-input v-model="submitData.checkinNote" type="textarea" class="is-border is-round bg-white" placeholder="請輸入內容" :autosize="{ minRows: 5 }" />
          </el-form-item>
        </div>

        <div>
          <h4 data-tour-text="" class="form-block-title mt-0">契約內容</h4>
          <el-form-item label="" prop="terms" :class="[$style['basicSetForm_inputContract']]">
            <div>
              <span class="isStyleRequired text-secondary">條款說明</span>
              <el-checkbox :value="useDefaultTerms" @change="setDefaultContact" label="引用系統提供的安親服務定型化契約"></el-checkbox>
            </div>
            <el-input v-model="submitData.terms" placeholder="請輸入條款" type="textarea" class="is-border is-round bg-white" :autosize="{ minRows: 7 }" :required="true" />
          </el-form-item>
        </div>
      </el-form>

      <div :class="$style.footer">
        <el-button class="is-round" @click="cancel">取消編輯</el-button>
        <el-button :loading="loading || storeStatus || createLoading" class="is-round" type="primary" @click="submit">儲存編輯</el-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.outer {
  overflow: scroll;
  width: 100%;
  padding: 18px 20px 0;
}
</style>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.container {
  background-color: #fff;
  padding: 18px 20px 40px;
}

.uploaderContainer {
  display: flex;

  &_uploader {
    border: none !important;

    > div {
      width: 382px;
      height: 216px;
      margin-bottom: 0;
    }
  }

  &_uploader + div {
    align-self: flex-end;
  }
}
</style>
